import React, {useCallback, useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux'
import endpoints, {getBackendUrl} from '../../../endpoints';
import {storage} from '../../../storage';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Alert from '@mui/material/Alert';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';
import Chip from '@mui/material/Chip';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import { formatDateTime } from '../../../helpers'
import DOMPurify from 'dompurify';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/AddRounded';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/DeleteRounded';
import ChatIcon from '@mui/icons-material/ChatRounded';
import { NavLink } from 'react-router-dom'
import Confirmation from '../modals/Confirmation';
import SelectTagModal from '../modals/SelectTagModal';
import CoversModal from '../modals/CoversModal';
import ContentNoteModal from '../modals/ContentNoteModal';
import InfoIcon from '@mui/icons-material/InfoRounded';
import VisibilityIcon from '@mui/icons-material/VisibilityRounded';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailReadRounded';
import CallMissedIcon from '@mui/icons-material/CallMissedRounded';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutlineRounded';
import BlockIcon from '@mui/icons-material/BlockRounded';
import AlarmOffIcon from '@mui/icons-material/AlarmOffRounded';
import Tooltip from '@mui/material/Tooltip';
import Badge from '@mui/material/Badge';

export default function AutoreplyTable(props) {
    const [contentDetailsItem, setContentDetailsItem] = useState()
    
    const token = useSelector((state) => state.auth.token)
        
    const rawMarkup = (content) => {
        var rawMarkup = content
        return { __html: DOMPurify.sanitize(rawMarkup) };
    }
    
    const getEmailColumn = (email) => {
        email = email.replace(/['"]+/g, '')
        
        let i = email.indexOf('<');
        
        if (i === -1) {
            return email
        }
        
        if (i === 0) {
            return email.replace('<', '').replace('>', '')
        }
        
        return (
            <Tooltip title={email.substr(i + 1, email.length - i - 2)}>
                {email.substr(0, i)}
            </Tooltip>
        )
    }
 
    return (
        <Stack spacing={1}>
            <Typography variant="h6" gutterBottom>
                <Stack spacing={3} direction="row" alignItems="end">
                    <div>Total items: {props.pagination?.total}</div>
                    {props.headerContent}
                </Stack>
            </Typography>
            <TableContainer component={Paper} sx={{overflowX: 'hidden'}}>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ minWidth: 220 }} align="left">From</TableCell>
                            <TableCell sx={{ width: '100%' }} align="left">Content</TableCell>
                            <TableCell sx={{ width: 40 }} align="center">Date/Time</TableCell>
                            <TableCell sx={{ width: 40 }} align="center">Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {props.items?.map((row) => (
                            <TableRow
                                hover
                                key={row.id}
                                sx={{ cursor: 'pointer' }}
                                onClick={() => {props.btnViewHandle(row)} }
                            >
                                <TableCell align="left" sx={{ maxWidth: 220, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                    {row.details?.spam == 'yes' ?
                                    <BlockIcon sx={{mt: -1, mb:-0.75, mr:1}} />
                                    : null }
                                    
                                    {row.details?.spam?.indexOf('Error:') == 0 ?
                                    <ErrorOutlineIcon sx={{mt: -1, mb:-0.75, mr:1}} />
                                    : null }
                                    
                                    {row.details ? null :
                                    <CallMissedIcon sx={{mt: -1, mb:-0.75, mr:1}} />
                                    }
                                    
                                    {row.details?.country ?
                                    <CallMissedIcon sx={{mt: -1, mb:-0.75, mr:1}} />
                                    : null }
                                    
                                    {row.sent_at ?
                                    <MarkEmailReadIcon sx={{mt: -1, mb:-0.75, mr:1}} />
                                    : null }
                                    
                                    {row.details?.time ?
                                    <AlarmOffIcon sx={{mt: -1, mb:-0.75, mr:1}} />
                                    : null }
                                    
                                    {getEmailColumn(row.input_from)}
                                </TableCell>
                                <TableCell 
                                    align="left" 
                                    sx={{maxWidth: 670, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}
                                >
                                    {row.input_subject || '(no subject)'} - {row.input_content || '(no content)'}
                                </TableCell>
                                <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
                                {formatDateTime(row.created_at)}
                                </TableCell>
                                <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
                                    <Tooltip title="View Item">
                                        <IconButton 
                                            component="label" 
                                            onClick={() => { props.btnViewHandle(row) }}
                                        >
                                            <VisibilityIcon />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Delete Item">
                                        <IconButton 
                                            component="label" 
                                            onClick={(e) => {e.stopPropagation(); props.btnDeleteHandle(row) }}
                                        >
                                            <DeleteIcon />
                                        </IconButton>
                                    </Tooltip>
                                </TableCell>
                            </TableRow>
                        ))}
                        {props.items?.length ? null :
                        <TableRow>
                            <TableCell colSpan={4} sx={{p:5, textAlign: 'center'}}>No data to display</TableCell>
                        </TableRow>
                        }
                    </TableBody>
                </Table>
                <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{p:1}}>
                    <Pagination page={props.pagination?.page} count={props.pagination?.pages} color="primary" onChange={(event, value) => { props.handlePaginate(value - 1) }} />

                    <FormControl sx={{ m: 1, minWidth: 120 }} size="small" variant="standard">
                        <InputLabel id="demo-select-small-label">Per page</InputLabel>
                        <Select
                            variant="standard"
                            labelId="demo-select-small-label"
                            id="demo-select-small"
                            value={props.pagination?.perpage}
                            defaultValue={props.pagination?.perpage}
                            label="Per page"
                            onChange={(event) => { props.handleChangePerpage(event.target.value) }}
                        >
                            <MenuItem value={10}>10</MenuItem>
                            <MenuItem value={20}>20</MenuItem>
                            <MenuItem value={50}>50</MenuItem>
                            <MenuItem value={100}>100</MenuItem>
                        </Select>
                    </FormControl>
                </Stack>
            </TableContainer>
        </Stack>
    );
}
